import IDB from './IDB'

const DB_NAMES = 'LOCAL_MUSIC'
const STORE_NAME = 'MUSIC_DATA'
const FETCH_CACHE_STORE_NAME = 'FETCH_CACHE'

function ensureObjectStore(db, storeName, keyPath) {
  if (!db.objectStoreNames.contains(storeName)) {
    db.createObjectStore(storeName, {
      keyPath,
    })
  }
}

export function createMusicIDB() {
  return new IDB(
    DB_NAMES,
    STORE_NAME,
    {
      onUpgrade(db) {
        try {
          ensureObjectStore(db, STORE_NAME, 'name')
          ensureObjectStore(db, FETCH_CACHE_STORE_NAME, 'key')
        } catch (error) {
          console.log(error)
        }
      },
    },
    2
  )
}

export function createFetchCacheIDB() {
  return new IDB(
    DB_NAMES,
    FETCH_CACHE_STORE_NAME,
    {
      onUpgrade(db) {
        try {
          ensureObjectStore(db, STORE_NAME, 'name')
          ensureObjectStore(db, FETCH_CACHE_STORE_NAME, 'key')
        } catch (error) {
          console.log(error)
        }
      },
    },
    2
  )
}

export function deduplicateArray(arr) {
  return [...new Set(arr)]
}
